export enum ErrorName {
    chunk = 'ChunkLoadError',
    type = 'TypeError',
}
